import React from "react";
import PropTypes from "prop-types";
import cloudStore from "../store/CloudStore";
import { IconButton } from "@material-ui/core";
import { VpnKey } from "@material-ui/icons";
import { useDialog } from "./Dialogs/DialogProvider";
import AuthenticationDialog from "./AuthenticationDialog/AuthenticationDialog";
import { authentications } from "../authorization/authorizations";

const authenticationRole = false;
// const authenticationRole = true;

// 0 not authorized
// 1 read
// 3 write
export const getPermission = (authentication) => {
  const checkPermissions = (type) => {
    if (cloudStore[type === "roles" ? "userRoles" : "userProfiles"] == null) {
      return 0;
    }
    if (authentication == null || authentication.length === 0) {
      return 0;
    }

    let authorized = 0;
    for (let i = 0; i < authentication.length; i++) {
      if (authentication[i][type].length === 0) {
        authorized = authorized | (authentication[i].authorized === "w" ? 3 : 1);
      }
      if (
        authentication[i]?.[type]?.some((authCombination) => {
          return authCombination.every((row) => {
            return cloudStore[type === "roles" ? "userRoles" : "userProfiles"]?.includes(row);
          });
        })
      ) {
        authorized = authorized | (authentication[i].authorized === "w" ? 3 : 1);
      }
    }
    return authorized;
  };

  const checkRoles = () => {
    return checkPermissions("roles");
  };

  const checkProfiles = () => {
    return checkPermissions("profiles");
  };

  const rolesAuthorized = checkRoles();
  const profilesAuthorized = checkProfiles();

  return rolesAuthorized & profilesAuthorized;
};

function AuthorizationWrapper(props) {
  const [openDialog] = useDialog();
  const permission = props.permission;

  const authentication = authentications[permission];

  const hasAuthenticationRole =
    cloudStore.userRoles?.includes("authentications") || (authenticationRole && process.env.NODE_ENV !== "production");

  const hasRolesDefined = authentication?.every((auth) => Array.isArray(auth.roles));
  const hasProfilesDefined = authentication?.every((auth) => Array.isArray(auth.profiles));
  const hasAuthorizedDefined = authentication?.every((auth) => auth.authorized != null);

  const authButtonWrapper = (children) => {
    if (hasAuthenticationRole && cloudStore.userRoles?.includes("superadmin")) {
      return (
        <div style={{ display: "flex", alignItems: "center" }}>
          <IconButton
            variant={hasAuthorizedDefined && hasProfilesDefined && hasRolesDefined ? "outlined" : "contained"}
            size={"small"}
            color={hasAuthorizedDefined && hasProfilesDefined && hasRolesDefined ? "default" : "secondary"}
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              openDialog({
                children: <AuthenticationDialog authentication={props.permission} />,
              });
            }}
          >
            <VpnKey />
          </IconButton>
          {children}
        </div>
      );
    } else {
      return children;
    }
  };

  let permissionCalculated = getPermission(authentication);

  if (authentication == null && process.env.NODE_ENV !== "production") {
    permissionCalculated = 3;
  }

  if (permissionCalculated === 0) {
    return authButtonWrapper(null);
  } else {
    if (typeof props.child === "function") {
      return authButtonWrapper(props.child(permissionCalculated === 3));
    } else {
      return authButtonWrapper(props.child);
    }
  }
}

AuthorizationWrapper.propTypes = {
  permission: PropTypes.array.isRequired,
  child: PropTypes.oneOfType([PropTypes.func, PropTypes.element]).isRequired,
};

export default AuthorizationWrapper;
